import React from "react";

import pill from "./../../../UI/general/pill.svg";
//import SidebargalleriesMobile from "./sidebarMobile.component";
import gallery from "./../../../UI/Modal/gallery.svg";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

interface Props {
  galleryData: any;
  colorsData: any;
}

interface State {
  isCollapsed: boolean;
  rgbaColor: any;
  galleryItemSelected: string;
  galleryIndexSelected: number;
  galleryIndexSelectedSub: number;
  galleryIndexGroupSelected: number;
  galleryIndexFolderSelected: number;
  galleryIndexFileSelected: number;
  selectedFile: string;
  breadCrumbs: any;
  SelectedGallery: boolean;
  isamenitiesHidden: boolean;
  show: boolean;
}
declare const window: any;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

class ContainerMobile extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isCollapsed: true,
      rgbaColor: "",
      galleryItemSelected: "",
      galleryIndexSelected: -1,
      galleryIndexSelectedSub: -1,
      galleryIndexGroupSelected: -1,
      galleryIndexFolderSelected: -1,
      galleryIndexFileSelected: -1,
      selectedFile: "",
      SelectedGallery: false,
      isamenitiesHidden: false,
      breadCrumbs: [],
      show: false,
    };
  }

  hexToRgb = (hexColor: any) => {
    hexColor = hexColor.replace(/^#/, ""); // Elimina el símbolo "#" al inicio
    const bigint = parseInt(hexColor, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `RGBA(${r}, ${g}, ${b}, 0.2)`;
  };
  render(): React.ReactNode {
    return (
      <>
        <div
          style={{
            width: "100%",
            height: "83%",
            overflowY: "auto",
            backgroundColor: "#FAFAFA",
          }}
        >
          {!this.state.SelectedGallery ? (
            <Grid
              container
              spacing={2}
              className={`gallery-preview-container-grid-mobile ${
                this.state.SelectedGallery ? "hidden" : ""
              }`}
            >
              {this.state.galleryIndexSelected >= 0 &&
              this.state.galleryIndexSelectedSub === -1
                ? this.props.galleryData[
                    this.state.galleryIndexSelected
                  ]?.galleries?.galleries?.flatMap(
                    (galleryGroup: any, ind: number) =>
                      galleryGroup?.map((fold: any, indexFold: number) =>
                        fold?.links?.map((file: any, index: number) => (
                          <Grid
                            item
                            xs={4}
                            sm={4}
                            md={4}
                            lg={4}
                            xl={4}
                            key={`${file.name}-${index}`}
                            className={`individual-gallery-grid-intro-mobile ${
                              this.state.SelectedGallery &&
                              this.state.galleryIndexGroupSelected ===
                                this.state.galleryIndexSelected &&
                              this.state.galleryIndexFolderSelected ===
                                indexFold &&
                              this.state.galleryIndexFileSelected === index
                                ? "selected"
                                : ""
                            }`}
                            onClick={() =>
                              this.setState({
                                selectedFile: file.link,
                                galleryIndexFileSelected: index,
                                galleryIndexGroupSelected:
                                  this.state.galleryIndexSelected,
                                galleryIndexFolderSelected: indexFold,
                                SelectedGallery: true,
                              })
                            }
                          >
                            <Item className="individual-gallery-item-intro-mobile">
                              <div className="individual-gallery-image-intro-mobile">
                                {/* <div>{fold?.name}</div> */}
                                {fold?.name !== "Recorridos" &&
                                fold?.name !== "Videos" ? (
                                  <img
                                    src={`${
                                      window.hybrid
                                        ? ""
                                        : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                                    }${file.link}`}
                                    alt={file.name}
                                  />
                                ) : (
                                  <iframe
                                    src={file.link}
                                    title="virtual-tours"
                                    width={"100%"}
                                    height="100%"
                                    style={{
                                      borderRadius: ".5rem",
                                      border: "none",
                                    }}
                                  />
                                )}
                                {/* <div className="overlay"></div> */}
                              </div>
                            </Item>
                          </Grid>
                        ))
                      )
                  )
                : this.state.galleryIndexSelectedSub >= 0
                ? this.props.galleryData[
                    this.state.galleryIndexSelected
                  ]?.galleries?.galleries[0][
                    this.state.galleryIndexSelectedSub
                  ]?.links?.map((file: any, index: number) => (
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      lg={4}
                      xl={4}
                      key={`${file.name}-${index}`}
                      className={`individual-gallery-grid-intro-mobile ${
                        this.state.SelectedGallery &&
                        this.state.galleryIndexGroupSelected ===
                          this.state.galleryIndexSelected &&
                        this.state.galleryIndexFolderSelected ===
                          this.state.galleryIndexSelectedSub &&
                        this.state.galleryIndexFileSelected === index
                          ? "selected"
                          : ""
                      }`}
                      onClick={() =>
                        this.setState({
                          selectedFile: file.link,
                          galleryIndexFileSelected: index,
                          galleryIndexGroupSelected:
                            this.state.galleryIndexSelected,
                          galleryIndexFolderSelected:
                            this.state.galleryIndexSelectedSub,
                          SelectedGallery: true,
                        })
                      }
                    >
                      <Item className="individual-gallery-item-intro-mobile">
                        <div className="individual-gallery-image-intro-mobile">
                          {/* <div>
                            {
                              this.props.galleryData[
                                this.state.galleryIndexSelected
                              ]?.galleries?.galleries[0][
                                this.state.galleryIndexSelectedSub
                              ]?.name
                            }
                          </div> */}
                          {this.props.galleryData[
                            this.state.galleryIndexSelected
                          ]?.galleries?.galleries[0][
                            this.state.galleryIndexSelectedSub
                          ]?.name !== "Recorridos" &&
                          this.props.galleryData[
                            this.state.galleryIndexSelected
                          ]?.galleries?.galleries[0][
                            this.state.galleryIndexSelectedSub
                          ]?.name !== "Videos" ? (
                            <img
                              src={`${
                                window.hybrid
                                  ? ""
                                  : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                              }${file.link}`}
                              alt={file.name}
                            />
                          ) : (
                            <iframe
                              src={file.link}
                              title="virtual-tours"
                              width={"100%"}
                              height="100%"
                              style={{
                                borderRadius: ".5rem",
                                border: "none",
                              }}
                            />
                          )}
                          {/* <div className="overlay"></div> */}
                        </div>
                      </Item>
                    </Grid>
                  ))
                : this.state.galleryIndexSelected === -1 &&
                  this.state.galleryIndexSelectedSub === -1
                ? this.props.galleryData?.map(
                    (primaryFolder: any, pfIndex: number) =>
                      primaryFolder?.galleries?.galleries?.flatMap(
                        (galleryGroup: any, ind: number) =>
                          galleryGroup?.map((fold: any, indexFold: number) =>
                            fold?.links?.map((file: any, index: number) => (
                              <Grid
                                item
                                xs={4}
                                sm={4}
                                md={4}
                                lg={4}
                                xl={4}
                                key={`${file.name}-${index}`}
                                className={`individual-gallery-grid-intro-mobile ${
                                  this.state.SelectedGallery &&
                                  this.state.galleryIndexGroupSelected ===
                                    pfIndex &&
                                  this.state.galleryIndexFolderSelected ===
                                    indexFold &&
                                  this.state.galleryIndexFileSelected === index
                                    ? "selected"
                                    : ""
                                }`}
                                onClick={() =>
                                  this.setState({
                                    selectedFile: file.link,
                                    galleryIndexFileSelected: index,
                                    galleryIndexGroupSelected: pfIndex,
                                    galleryIndexFolderSelected: indexFold,
                                    SelectedGallery: true,
                                  })
                                }
                              >
                                <Item className="individual-gallery-item-intro-mobile">
                                  <div className="individual-gallery-image-intro-mobile">
                                    {/* <div>{fold?.name}</div> */}
                                    {fold?.name !== "Recorridos" &&
                                    fold?.name !== "Videos" ? (
                                      <img
                                        src={`${
                                          window.hybrid
                                            ? ""
                                            : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                                        }${file.link}`}
                                        alt={file.name}
                                      />
                                    ) : (
                                      <iframe
                                        src={file.link}
                                        title="virtual-tours"
                                        width={"100%"}
                                        height="100%"
                                        style={{
                                          borderRadius: ".5rem",
                                          border: "none",
                                          pointerEvents: "none",
                                        }}
                                      />
                                    )}
                                    {/* <div className="overlay"></div> */}
                                  </div>
                                </Item>
                              </Grid>
                            ))
                          )
                      )
                  )
                : null}
            </Grid>
          ) : (
            <>
              <div className="only-gallery-selected-container-opciones-descripcion-mobile">
                <div>
                  {
                    this.props.galleryData[
                      this.state.galleryIndexGroupSelected
                    ]?.galleries?.galleries[0][
                      this.state.galleryIndexFolderSelected
                    ]?.links[this.state.galleryIndexFileSelected].name.split(
                      "."
                    )[0]
                  }
                </div>
                <div style={{ color: "#434343", fontSize: "0.7rem" }}>
                  {
                    this.props.galleryData[this.state.galleryIndexGroupSelected]
                      ?.galleries?.galleries[0][
                      this.state.galleryIndexFolderSelected
                    ]?.name
                  }
                </div>
              </div>
              <div
                className={`only-gallery-selected-container-mobile ${
                  !this.state.SelectedGallery ? "closing" : "visibility"
                }`}
              >
                {this.props.galleryData[this.state.galleryIndexGroupSelected]
                  ?.galleries?.galleries[0][
                  this.state.galleryIndexFolderSelected
                ]?.name !== "Recorridos" &&
                this.props.galleryData[this.state.galleryIndexGroupSelected]
                  ?.galleries?.galleries[0][
                  this.state.galleryIndexFolderSelected
                ]?.name !== "Videos" ? (
                  <img
                    src={`${
                      window.hybrid
                        ? ""
                        : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                    }${this.state.selectedFile}`}
                    alt=""
                  />
                ) : (
                  <iframe
                    src={this.state.selectedFile}
                    title="virtual-tours"
                    width={"100%"}
                    height="100%"
                    style={{
                      borderRadius: ".5rem",
                      border: "none",
                    }}
                  />
                )}
              </div>
              <div
                style={{
                  display: "-webkit-box",
                  marginTop: "10%",
                  overflowX: "auto",
                }}
              >
                {this.state.galleryIndexSelected >= 0 &&
                this.state.galleryIndexSelectedSub === -1
                  ? this.props.galleryData[
                      this.state.galleryIndexSelected
                    ]?.galleries?.galleries?.flatMap(
                      (galleryGroup: any, ind: number) =>
                        galleryGroup?.map((fold: any, indexFold: number) =>
                          fold?.links?.map((file: any, index: number) => (
                            <div
                              key={`${file.name}-${index}`}
                              className={`only-individual-gallery-grid-intro-mobile ${
                                this.state.SelectedGallery &&
                                this.state.galleryIndexGroupSelected ===
                                  this.state.galleryIndexSelected &&
                                this.state.galleryIndexFolderSelected ===
                                  indexFold &&
                                this.state.galleryIndexFileSelected === index
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                this.setState({
                                  selectedFile: file.link,
                                  galleryIndexFileSelected: index,
                                  galleryIndexGroupSelected:
                                    this.state.galleryIndexSelected,
                                  galleryIndexFolderSelected: indexFold,
                                  SelectedGallery: true,
                                })
                              }
                            >
                              <Item className="individual-gallery-item-intro-mobile">
                                <div className="individual-gallery-image-intro-mobile">
                                  {/* <div>{fold?.name}</div> */}
                                  {this.state.SelectedGallery &&
                                  this.state.galleryIndexGroupSelected ===
                                    this.state.galleryIndexSelected &&
                                  this.state.galleryIndexFolderSelected ===
                                    indexFold &&
                                  this.state.galleryIndexFileSelected ===
                                    index ? (
                                    <div
                                      className="selected-gallery"
                                      style={{
                                        backgroundColor: `${this.hexToRgb(
                                          this.props.colorsData.main_buttons
                                        )}`,
                                      }}
                                    ></div>
                                  ) : null}
                                  {fold?.name !== "Recorridos" &&
                                  fold?.name !== "Videos" ? (
                                    <img
                                      src={`${
                                        window.hybrid
                                          ? ""
                                          : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                                      }${file.link}`}
                                      alt={file.name}
                                    />
                                  ) : (
                                    <iframe
                                      src={file.link}
                                      title="virtual-tours"
                                      width={"100%"}
                                      height="100%"
                                      style={{
                                        borderRadius: ".5rem",
                                        border: "none",
                                        pointerEvents: "none",
                                      }}
                                    />
                                  )}
                                  {/* <div className="overlay"></div> */}
                                </div>
                              </Item>
                            </div>
                          ))
                        )
                    )
                  : this.state.galleryIndexSelectedSub >= 0
                  ? this.props.galleryData[
                      this.state.galleryIndexSelected
                    ]?.galleries?.galleries[0][
                      this.state.galleryIndexSelectedSub
                    ]?.links?.map((file: any, index: number) => (
                      <div
                        key={`${file.name}-${index}`}
                        className={`only-individual-gallery-grid-intro-mobile ${
                          this.state.SelectedGallery &&
                          this.state.galleryIndexGroupSelected ===
                            this.state.galleryIndexSelected &&
                          this.state.galleryIndexFolderSelected ===
                            this.state.galleryIndexSelectedSub &&
                          this.state.galleryIndexFileSelected === index
                            ? "selected"
                            : ""
                        }`}
                        onClick={() =>
                          this.setState({
                            selectedFile: file.link,
                            galleryIndexFileSelected: index,
                            galleryIndexGroupSelected:
                              this.state.galleryIndexSelected,
                            galleryIndexFolderSelected:
                              this.state.galleryIndexSelectedSub,
                            SelectedGallery: true,
                          })
                        }
                      >
                        <Item className="individual-gallery-item-intro-mobile">
                          <div className="individual-gallery-image-intro-mobile">
                            {/* <div>
                            {
                              this.props.galleryData[
                                this.state.galleryIndexSelected
                              ]?.galleries?.galleries[0][
                                this.state.galleryIndexSelectedSub
                              ]?.name
                            }
                          </div> */}
                            {this.state.SelectedGallery &&
                            this.state.galleryIndexGroupSelected ===
                              this.state.galleryIndexSelected &&
                            this.state.galleryIndexFolderSelected ===
                              this.state.galleryIndexSelectedSub &&
                            this.state.galleryIndexFileSelected === index ? (
                              <div
                                className="selected-gallery"
                                style={{
                                  backgroundColor: `${this.hexToRgb(
                                    this.props.colorsData.main_buttons
                                  )}`,
                                }}
                              ></div>
                            ) : null}

                            {this.props.galleryData[
                              this.state.galleryIndexSelected
                            ]?.galleries?.galleries[0][
                              this.state.galleryIndexSelectedSub
                            ]?.name !== "Recorridos" &&
                            this.props.galleryData[
                              this.state.galleryIndexSelected
                            ]?.galleries?.galleries[0][
                              this.state.galleryIndexSelectedSub
                            ]?.name !== "Videos" ? (
                              <img
                                src={`${
                                  window.hybrid
                                    ? ""
                                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                                }${file.link}`}
                                alt={file.name}
                              />
                            ) : (
                              <iframe
                                src={file.link}
                                title="virtual-tours"
                                width={"100%"}
                                height="100%"
                                style={{
                                  borderRadius: ".5rem",
                                  border: "none",
                                  pointerEvents: "none",
                                }}
                              />
                            )}
                            {/* <div className="overlay"></div> */}
                          </div>
                        </Item>
                      </div>
                    ))
                  : this.state.galleryIndexSelected === -1 &&
                    this.state.galleryIndexSelectedSub === -1
                  ? this.props.galleryData?.map(
                      (primaryFolder: any, pfIndex: number) =>
                        primaryFolder?.galleries?.galleries?.flatMap(
                          (galleryGroup: any, ind: number) =>
                            galleryGroup?.map((fold: any, indexFold: number) =>
                              fold?.links?.map((file: any, index: number) => (
                                <div
                                  key={`${file.name}-${index}`}
                                  className={`only-individual-gallery-grid-intro-mobile ${
                                    this.state.SelectedGallery &&
                                    this.state.galleryIndexGroupSelected ===
                                      pfIndex &&
                                    this.state.galleryIndexFolderSelected ===
                                      indexFold &&
                                    this.state.galleryIndexFileSelected ===
                                      index
                                      ? "selected"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.setState({
                                      selectedFile: file.link,
                                      galleryIndexFileSelected: index,
                                      galleryIndexGroupSelected: pfIndex,
                                      galleryIndexFolderSelected: indexFold,
                                      SelectedGallery: true,
                                    })
                                  }
                                >
                                  <Item className="individual-gallery-item-intro-mobile">
                                    <div className="individual-gallery-image-intro-mobile">
                                      {/* <div>{fold?.name}</div> */}
                                      {this.state.SelectedGallery &&
                                      this.state.galleryIndexGroupSelected ===
                                        pfIndex &&
                                      this.state.galleryIndexFolderSelected ===
                                        indexFold &&
                                      this.state.galleryIndexFileSelected ===
                                        index ? (
                                        <div
                                          className="selected-gallery"
                                          style={{
                                            backgroundColor: `${this.hexToRgb(
                                              this.props.colorsData.main_buttons
                                            )}`,
                                          }}
                                        ></div>
                                      ) : null}
                                      {fold?.name !== "Recorridos" &&
                                      fold?.name !== "Videos" ? (
                                        <img
                                          src={`${
                                            window.hybrid
                                              ? ""
                                              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                                          }${file.link}`}
                                          alt={file.name}
                                        />
                                      ) : (
                                        <iframe
                                          src={file.link}
                                          title="virtual-tours"
                                          width={"100%"}
                                          height="100%"
                                          style={{
                                            borderRadius: ".5rem",
                                            border: "none",
                                            pointerEvents: "none",
                                          }}
                                        />
                                      )}
                                      {/* <div className="overlay"></div> */}
                                    </div>
                                  </Item>
                                </div>
                              ))
                            )
                        )
                    )
                  : null}
              </div>
            </>
          )}
        </div>
        <div
          className={
            this.state.isamenitiesHidden
              ? "gallery-sidebar-container-collapsed"
              : "gallery-sidebar-container-opened"
          }
          style={{ pointerEvents: "all" }}
        >
          <div
            className="hide-amenities-mobile-container"
            onClick={() => {
              this.setState({
                isamenitiesHidden: !this.state.isamenitiesHidden,
              });
            }}
          >
            <img src={pill} alt=""></img>
          </div>
          {!this.state.isamenitiesHidden ? (
            <>
              <div className="options-amenities-container-mobile">
                <div className="options-amenities-name">
                  <img src={gallery} alt="" />
                  <div>GALERÍA</div>
                </div>
                <div className="options-amenities-btns-container">
                  {this.props.galleryData.map((group: any, index: number) => (
                    <div
                      className="options-amenity-individual-btn"
                      style={{
                        backgroundColor:
                          this.state.galleryIndexSelected === index
                            ? this.props.colorsData.main_buttons
                            : "#fafafa",
                      }}
                      onClick={() => {
                        this.setState({
                          galleryItemSelected:
                            this.state.galleryItemSelected === group.name
                              ? ""
                              : group.name,
                          galleryIndexSelected:
                            this.state.galleryItemSelected === group.name
                              ? -1
                              : index,
                          galleryIndexSelectedSub: -1,
                          SelectedGallery: false,
                        });
                      }}
                    >
                      <img
                        src={
                          (window.hybrid
                            ? ""
                            : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                          group.background
                        }
                        alt=""
                        style={{
                          filter:
                            this.state.galleryIndexSelected === index
                              ? "invert(1) brightness(100%)"
                              : "none",
                        }}
                      ></img>
                      <div
                        className="options-amenity-individual-name"
                        style={{
                          color:
                            this.state.galleryIndexSelected === index
                              ? this.props.colorsData.secondary_text
                              : this.props.colorsData.main_text,
                        }}
                      >
                        {group.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {this.state.galleryIndexSelected !== -1 ? (
                <div className="amenities-options-selection-menu-mobile">
                  {this.props.galleryData[
                    this.state.galleryIndexSelected
                  ].galleries.galleries[0].map((folder: any, index: number) => (
                    <div
                      className="options-selection-menu-mobile-individual"
                      key={folder.name + index}
                      style={{
                        backgroundColor:
                          this.state.galleryIndexSelectedSub === index
                            ? this.props.colorsData.main_buttons
                            : "#fafafa",
                      }}
                      onClick={() => {
                        this.setState(
                          {
                            breadCrumbs: [],
                            galleryIndexSelectedSub:
                              this.state.galleryIndexSelectedSub === index
                                ? -1
                                : index,
                            SelectedGallery: false,
                          },
                          () => {
                            this.state.breadCrumbs.push(
                              this.state.galleryItemSelected
                            );
                            this.state.breadCrumbs.push(gallery.name);
                            /* this.props.handleGalleriesSelection(
                                    gallery,
                                    this.state.breadCrumbs,
                                    true
                                  ); */
                          }
                        );
                      }}
                    >
                      <img
                        src={folder.icon}
                        alt={""}
                        style={{
                          filter:
                            this.state.galleryIndexSelectedSub === index
                              ? "invert(1) brightness(200%)"
                              : "none",
                        }}
                      />
                      <div
                        className="amenity-individual-name"
                        style={{
                          color:
                            this.state.galleryIndexSelectedSub === index
                              ? this.props.colorsData.secondary_text
                              : this.props.colorsData.main_text,
                        }}
                      >
                        {folder.name}
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      </>
    );
  }
}

export default ContainerMobile;
